import { gql } from '../../../../../hooks'

export const DELETE_CHANGE_MOTIVES = gql`
  mutation AdministrationDeleteComponentChangeMotives($id: ID!) {
    aDelete(path: "component/change/motives", id: $id) {
    }
  }
`

export const LIST_CHANGE_MOTIVES = gql`
  query AdministrationListComponentChangeMotives(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/change/motives"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
